import * as React from "react";
export const Root = React.lazy(() => import("@/widgets/app-layout/Root"));
export const NotFound = React.lazy(
  () => import("@/pages/not-found/NotFound"),
);
export const LinkExpiredPage = React.lazy(
  () => import("@/pages/link-expired/LinkExpiredPage"),
);
// Legacy `pages/unauthorized/unAuthorize.tsx` is retired — it wasn't
// wired to the design system and rendered as a broken 403 layout
// (giant "403" glyph overlapping the buttons + fullscreen upper-case
// title). The `/unauthorized_access` route now renders the same
// ErrorStatePage as every other error state, with statusCode=403.
export const UnAuthorized = React.lazy(
  () => import("@/pages/ErrorState/ErrorStatePage"),
);
export const ErrorFallback = React.lazy(
  () => import("@/shared/ui/error/ErrorFallBack"),
);
//
export const Layout = React.lazy(() => import("@/widgets/app-layout/Layout"));
export const Home = React.lazy(() => import("@/pages/home/Home"));
export const LoginPage = React.lazy(
  () => import("@/features/auth/ui/LoginPage"),
);
export const SignupPage = React.lazy(
  () => import("@/features/auth/ui/SignupPage"),
);
export const PublicLegalDocumentPage = React.lazy(
  () => import("@/pages/public/legal/PublicLegalDocumentPage"),
);

export const RequirePermission = React.lazy(
  () => import("./guards/RequirePermission"),
);

export const AdminProfile = React.lazy(
  () => import("@/pages/vendor/settings/Profile"),
);
export const AdminThemeSettings = React.lazy(
  () => import("@/pages/vendor/settings/ThemeSettings"),
);

export const AdminStoreSettings = React.lazy(
  () => import("@/pages/vendor/settings/StoreSetting"),
);
export const AdminIntegrations = React.lazy(
  () => import("@/pages/vendor/settings/Integrations"),
);
// Landing route for the Instagram authorization. The API's redirectPath
// allowlist holds two bare, non-store-scoped paths; this component resolves
// the store and forwards the outcome parameters on.
export const SocialReturnLanding = React.lazy(() =>
  import("@/features/social-import").then((m) => ({
    default: m.SocialReturnLanding,
  })),
);
export const AdminHome = React.lazy(
  () => import("@/widgets/dashboard/Dashboard"),
);
export const SystemAdminHome = React.lazy(
  () => import("@/widgets/system-admin/home/SystemAdminHome"),
);
export const AdminProduct = React.lazy(
  () => import("@/widgets/product-management/product"),
);
export const NotificationsPage = React.lazy(
  () => import("@/widgets/notifications/NotificationsPage"),
);

// Route entry for the gallery: resolves the store's business-type code, then
// renders the embedded Studio frame filtered to it.
//
// The legacy in-dashboard gallery / preview / editor were lazy-imported here
// as fallbacks. They are out of the route table now — the Studio is the only
// template surface. The widget files still exist under widgets/template-*,
// but nothing imports them, so they never enter a bundle.
export const TemplatesRoutePage = React.lazy(
  () => import("@/pages/store/TemplatesRoutePage"),
);

export const BillingPage = React.lazy(
  () => import("@/features/billing/BillingPage"),
);

export const OnboardingGate = React.lazy(
  () => import("@/features/onboarding/OnboardingGate"),
);

export const PaymentSettingsPage = React.lazy(
  () => import("@/features/payment-settings/ui/PaymentSettingsPage"),
);
export const StripeReturnPage = React.lazy(
  () => import('@/pages/vendor/stripe-return'),
);
export const StripeRefreshPage = React.lazy(
  () => import('@/pages/vendor/stripe-refresh'),
);
